export default __webpack_public_path__ + "static/media/img19.a9961a4e.jpg";